import { render } from "./ResearchView.vue?vue&type=template&id=779ee0ea&scoped=true"
import script from "./ResearchView.vue?vue&type=script&lang=js"
export * from "./ResearchView.vue?vue&type=script&lang=js"

import "./ResearchView.vue?vue&type=style&index=0&id=779ee0ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779ee0ea"]])

export default __exports__